export const fabricatorCommentsSpacer = {
    height: "50px"
}